import AlumniEvents from "./Alumnus_Network/Alumni_Events";
import SuccessStories from "./Alumnus_Network/Success_Stories";

import "./Css/Alumnus_Network.css";

function AlumnusNetwork() {
  return (
    <div>
      <AlumniEvents />
      <SuccessStories />
    </div>
  );
}

export default AlumnusNetwork;
